module.exports = __webpack_public_path__ + "static/media/empty-favorite.66659c30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/empty-favorite.svg
// module id = 227
// module chunks = 49